import { p as e } from "../parseISO-wlfIB_QJ.js";
import { i as t } from "../isValid-DN-HkCoi.js";
function n(r) {
  if (isNaN(Date.parse(r)))
    return;
  const a = e(r);
  return t(a) ? a : new Date(r);
}
export {
  n as default
};
//# sourceMappingURL=createValidDate.js.map
